<template>
  <div class="global-box footer diff">
    <div class="wraper-logotype">
      <icon description="rep-brand-leaked" class="rep-brand-leaked" size="80" />
    </div>
    <div class="content-box">
      <div class="description-company">
        <p class="description">
          {{$t('index.footer.text_business')}}
        </p>
      </div>
      <div class="middle">
        <p>
          {{$t('index.footer.keywords')}}
        </p>
      </div>
      <div class="contacts">
        <p class="contact-mail">
          team@represente.com.br
        </p>
        <social-media />
      </div>
    </div>
    <div class="wrapper">
      <div class="copyright">
          <p>
            {{$t('index.footer.copyright')}} {{new Date().getFullYear()}} -
            {{$t('index.footer.text_complement')}}
            <span>
              {{$t('index.footer.represente')}}.
            </span>
          </p>
      </div>
      <div class="click-gestao">
          <a href="https://clickgestao.com.br" target="_blank">
          <p>um produto:</p>
          <img src="https://clickgestao.com.br/img/brand-click-gestao.svg" />
          </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer-session',
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .footer
    background-color: $primary
    overflow: initial !important
    display: flex
    flex-wrap: wrap
    justify-content: center
    .wraper-logotype
      width: 100%
      display: flex
      justify-content: center
      .rep-brand-leaked
        margin: 10px 0
        fill: transparent
        stroke: $grey-800
        stroke-width: 10
    .content-box
      display: flex
      flex-wrap: nowrap
      justify-content: space-between
      align-items: flex-start
      .description-company, .middle, .contacts
        width: 25%
      .description-company
        display: flex
        flex-wrap: wrap
        justify-content: center
        .description
          width: 100%
          text-align: justify
      .middle
        p
          text-transform: lowercase
          text-align: center
          font-weight: 300
      .contacts
        text-align: center
        .contact-mail
          font-weight: 600
          color: $grey-800
    .wrapper
      width: 1200px
      display: flex
      align-items: flex-end
      padding: 12px 8px
      .copyright
        width: calc(100% - 140px)
        p
          width: 100%
          font-weight: 300
          font-size: 14px
          font-style: italic
          color: $black
          text-align: center
          padding-left: 24px
          text-transform: lowercase
          padding-left: 140px
      .click-gestao
        display: flex
        flex-wrap: wrap
        justify-content: flex-start
        p
          width: 100%
          color: $black
          text-align: center
          font-weight: 300
          text-transform: lowercase
          font-size: 10px
          margin-bottom: 4px
        img
          width: 140px
        @media (max-width: $widthTerciary)
          width: 100%
          justify-content: center
          p
            text-align: center
          img
            width: 140px
    @media (max-width: $widthTerciary)
      .content-box
        display: flex
        flex-wrap: wrap
        .description-company, .middle, .contacts
          width: 100%
          margin-bottom: 20px
        .middle
          margin-top: -10px
          margin-bottom: 40px
          p
            text-align: justify
      .wrapper
        flex-wrap: wrap
        padding: 4px 16px
        .copyright
          width: 100%
          margin-bottom: 20px
          p
            padding-left: 0
</style>
